/* eslint-disable no-magic-numbers */
import React from 'react';
import { ModelElement } from '@/types/models';
import { ElementDiagramPreview } from '@/components/FunctionalArea/Modal/EditElementModal/ElementDiagramPreview.component';

type ElementPreviewPanelProps = {
  modelElement?: ModelElement;
};

export const ElementPreviewPanel: React.FC<ElementPreviewPanelProps> = ({ modelElement }) => {
  return (
    <div className="relative flex h-[220px] w-full shrink-0 items-center justify-center overflow-hidden rounded border">
      {modelElement && (
        <ElementDiagramPreview
          x={modelElement.x}
          y={modelElement.y}
          width={modelElement.width}
          height={modelElement.height}
        />
      )}
    </div>
  );
};
